const translations = {
  "en": {
    "Address": "Address",
    "Circulating Supply": "Circulating Supply",
    "Date of Creation": "Date of Creation",
    "DEX": "DEX",
    "FDV": "FDV",
    "Funding Rate": "Funding Rate",
    "Holders": "Holders",
    "Key Stats": "Key Stats",
    "Liquidity": "Liquidity",
    "Makers (24hr)": "Makers (24hr)",
    "Market Cap": "Market Cap",
    "Max Supply": "Max Supply",
    "Total Supply": "Total Supply",
    "Trading Volume (24hr)": "Trading Volume (24hr)",
    "Txns24h": "Txns24h"
  },
  "zh-tw": {
    "Address": "地址",
    "Circulating Supply": "流通供應量",
    "Date of Creation": "建立日期",
    "DEX": "DEX",
    "FDV": "FDV",
    "Funding Rate": "資金費率",
    "Holders": "持有者",
    "Key Stats": "關鍵數據",
    "Liquidity": "流動性",
    "Makers (24hr)": "掛單數量 (24小時)",
    "Market Cap": "市值",
    "Max Supply": "最大供應量",
    "Total Supply": "總供應量",
    "Trading Volume (24hr)": "交易量 (24小時)",
    "Txns24h": "24小時交易數"
  }
};

export default translations;
